(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-progress-bar"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = '.illumikids-shipping-progress';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const offsets = [
      [-32, -25, -42], [-23, -39, 30], [-11, -31, 72], [5, -42, -35],
      [24, -32, 45], [34, -17, -65], [-35, 3, 55], [-21, 13, -35],
      [10, 15, 60], [29, 9, -50]
    ];

    function progressState(bar) {
      const goal = Number(bar.dataset.goalShopCents);
      const total = Number(bar.dataset.cartTotalCents);
      const isQuantity = bar.dataset.isQuantity === 'true';
      if (isQuantity) {
        const quantityGoal = Number(bar.dataset.goalQuantity);
        const quantity = Number(bar.dataset.cartItemQuantity);
        const crossed = quantityGoal > 0 && quantity >= quantityGoal;
        const reached = crossed || bar.dataset.subAutoComplete === 'true';
        return { reached, crossed, progress: reached ? 100 : quantityGoal > 0 ? Math.round(quantity / quantityGoal * 100) : 0 };
      }
      const active = window.Shopify?.currency?.active;
      const rate = Number(window.Shopify?.currency?.rate);
      const convertedGoal = active && active !== bar.dataset.shopCurrency && rate > 0 ? goal * rate : goal;
      const crossed = convertedGoal > 0 && total >= convertedGoal;
      const reached = crossed || bar.dataset.subAutoComplete === 'true';
      return { reached, crossed, progress: reached ? 100 : convertedGoal > 0 ? Math.round(total / convertedGoal * 100) : 0 };
    }

    function celebrate(bar) {
      if (reducedMotion.matches) return;
      const layer = bar.querySelector('.illumikids-shipping-progress__confetti');
      if (!layer) return;
      layer.replaceChildren();
      const pieces = document.createDocumentFragment();
      offsets.forEach(([x, y, rotation], index) => {
        const piece = document.createElement('span');
        piece.className = 'illumikids-shipping-progress__piece';
        piece.style.setProperty('--confetti-x', `${x}px`);
        piece.style.setProperty('--confetti-y', `${y}px`);
        piece.style.setProperty('--confetti-rotation', `${rotation}deg`);
        piece.style.setProperty('--confetti-delay', `${index % 3 * 35}ms`);
        pieces.appendChild(piece);
      });
      layer.appendChild(pieces);
      window.setTimeout(() => layer.replaceChildren(), 1200);
    }

    function init() {
      const drawer = document.querySelector('#CartDrawer');
      if (!drawer) return;
      const bar = drawer.querySelector(selector);
      let lastCrossed = bar ? progressState(bar).crossed : false;
      let lastBar = bar;
      let lastProgress = Number.parseFloat(bar?.querySelector('.cart-progress__bar__progress')?.style.width);
      let pending = false;

      const sync = () => {
        pending = false;
        const current = drawer.querySelector(selector);
        if (!current) {
          if (drawer.closest('cart-drawer')?.classList.contains('is-empty')) lastCrossed = false;
          lastBar = null;
          lastProgress = NaN;
          return;
        }
        const state = progressState(current);
        const fill = current.querySelector('.cart-progress__bar__progress');
        const targetProgress = Number.parseFloat(fill?.style.width);
        if (current !== lastBar && fill && Number.isFinite(lastProgress) && Number.isFinite(targetProgress) && targetProgress !== lastProgress && !reducedMotion.matches) {
          const transition = fill.style.transition;
          fill.style.transition = 'none';
          fill.style.width = `${lastProgress}%`;
          fill.getBoundingClientRect();
          fill.style.transition = transition;
          fill.style.width = `${targetProgress}%`;
        }
        lastBar = current;
        lastProgress = targetProgress;
        current.classList.toggle('is-unlocked', state.reached);
        current.querySelector('[role="progressbar"]')?.setAttribute('aria-valuenow', String(Math.max(0, Math.min(100, state.progress || 0))));
        if (state.crossed && !lastCrossed) celebrate(current);
        lastCrossed = state.crossed;
      };

      new MutationObserver((changes) => {
        if (changes.every(change => change.target.closest?.('.illumikids-shipping-progress__confetti'))) return;
        if (pending) return;
        pending = true;
        queueMicrotask(sync);
      }).observe(drawer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-cart-total-cents', 'data-sub-auto-complete']
      });
      sync();
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    else init();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["illumikids-bundles"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('illumikids-bundles')) {
    customElements.define('illumikids-bundles', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.cards = [...this.querySelectorAll('.kb-card')];
        this.sizePicker = this.querySelector('.kb-size-picker');
        this.form = document.getElementById(`product-form-${this.dataset.section}`);
        if (!this.form) { this.controller = null; return; }
        this.button = this.form.querySelector('[type="submit"]');
        this.error = this.querySelector('.kb-error');
        try {
          this.variantMedia = JSON.parse(`{${this.querySelector('[data-kb-variant-media]')?.textContent || ''}}`);
        } catch (_) {
          this.variantMedia = {};
        }
        this.money = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency: this.dataset.currency || 'EUR' });
        const sizeOptions = this.sizePicker?.querySelector('.kb-size-options');
        const sizeInputs = [...(sizeOptions?.querySelectorAll('.kb-size-option input[type="radio"]') || [])];
        const syncSizeIndicator = () => sizeOptions?.classList.toggle('is-large', Boolean(sizeInputs[1]?.checked));
        this.addEventListener('change', (event) => {
          const card = event.target.closest('.kb-card');
          if (this.sizePicker?.contains(event.target)) {
            syncSizeIndicator();
            this.cards.forEach(bundleCard => {
              bundleCard.querySelectorAll('select').forEach(select => { select.value = event.target.value; });
              bundleCard.dataset.activeVariant = event.target.value;
            });
            this.refresh();
            this.syncGallery(event.target.value);
            return;
          }
          if (!card) return;
          if (event.target.matches('select') && !card.dataset.personalized) {
            if (event.target.dataset.index === '1') card.querySelectorAll('select').forEach(select => { select.value = event.target.value; });
            card.dataset.personalized = 'true';
          }
          if (event.target.matches('select')) card.dataset.activeVariant = event.target.value;
          this.refresh();
          const activeVariant = card.dataset.activeVariant || card.querySelector('select').value;
          this.sizePicker?.querySelectorAll('input[type="radio"]').forEach(input => {
            input.checked = input.value === activeVariant;
          });
          syncSizeIndicator();
          this.syncGallery(activeVariant);
        }, options);
        if (sizeOptions) {
          let swipeStart = null;
          sizeOptions.addEventListener('touchstart', event => {
            if (event.touches.length !== 1) { swipeStart = null; return; }
            const touch = event.touches[0];
            swipeStart = { id: touch.identifier, x: touch.clientX, y: touch.clientY };
          }, { ...options, passive: true });
          sizeOptions.addEventListener('touchend', event => {
            if (!swipeStart) return;
            const touch = [...event.changedTouches].find(item => item.identifier === swipeStart.id);
            if (!touch) return;
            const dx = touch.clientX - swipeStart.x;
            const dy = touch.clientY - swipeStart.y;
            swipeStart = null;
            if (Math.abs(dx) < 32 || Math.abs(dx) <= Math.abs(dy) * 1.25) return;
            event.preventDefault();
            const target = sizeInputs[dx > 0 ? 1 : 0];
            if (target && !target.disabled && !target.checked) {
              target.checked = true;
              target.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }, { ...options, passive: false });
          sizeOptions.addEventListener('touchcancel', () => { swipeStart = null; }, options);
        }
        this.addEventListener('click', (event) => {
          const toggle = event.target.closest('[data-mix-toggle]');
          const card = toggle?.closest('.kb-card');
          if (!card) return;
          card.dataset.mixOpen = 'true';
          this.refresh();
          card.querySelector('.kb-sizes select')?.focus();
        }, options);
        this.form.addEventListener('submit', event => this.submit(event), { ...options, capture: true });
        syncSizeIndicator();
        this.refresh();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
      syncGallery(variantId) {
        const input = this.form?.querySelector('[name="id"]');
        if (input) { input.value = variantId; input.dispatchEvent(new Event('change', { bubbles: true })); }
        const mediaId = this.variantMedia?.[String(variantId)];
        const gallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
        if (mediaId && typeof gallery?.setActiveMedia === 'function') {
          gallery.setActiveMedia(`${this.dataset.section}-${mediaId}`, true);
        }
      }
      refresh() {
        const folded = this.dataset.foldSizes === 'true';
        this.cards.forEach(card => {
          const selected = card.querySelector('input').checked;
          card.classList.toggle('is-selected', selected);
          const mixOpen = card.dataset.mixOpen === 'true';
          const multiBoard = Number(card.dataset.quantity) > 1;
          card.querySelector('.kb-sizes').hidden = !selected || (folded && !(multiBoard && mixOpen));
          const toggle = card.querySelector('[data-mix-toggle]');
          if (toggle) {
            toggle.hidden = !selected || mixOpen;
            toggle.setAttribute('aria-expanded', String(mixOpen));
          }
          const selects = [...card.querySelectorAll('select')];
          const totalsByVariant = new Map();
          for (const select of selects) {
            const option = select.selectedOptions[0];
            totalsByVariant.set(select.value, (totalsByVariant.get(select.value) || 0) + Number(option?.dataset.price || 0));
          }
          const subtotal = [...totalsByVariant.values()].reduce((sum, cents) => sum + cents, 0);
          const rate = Number(card.dataset.multiplier) === 90 ? 1001 : Number(card.dataset.multiplier) === 85 ? 1501 : 0;
          const discounted = subtotal - Math.floor(subtotal * rate / 10000);
          card.querySelector('[data-total]').textContent = this.money.format(discounted / 100);
          const original = card.querySelector('[data-original]');
          const reference = selects.reduce((sum, select) => sum + Math.max(Number(select.selectedOptions[0]?.dataset.compare || 0), Number(select.selectedOptions[0]?.dataset.price || 0)), 0);
          original.textContent = this.money.format(reference / 100);
          original.hidden = reference <= discounted;
          const saving = card.querySelector('[data-base-saving]');
          if (saving) {
            saving.hidden = reference <= discounted;
            saving.textContent = `−${Math.round((reference - discounted) * 1000 / reference) / 10}%`;
          }
          if (selected) {
            this.selected = card;
            const variantInput = this.form.querySelector('[name="id"]');
            if (variantInput) variantInput.value = selects[0].value;
          }
        });
      }
      async submit(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.pending) return;
        this.error.hidden = true;
        if (!this.dataset.gift || this.dataset.giftReady !== 'true') {
          this.error.textContent = this.dataset.giftError;
          this.error.hidden = false;
          return;
        }
        this.pending = true;
        this.setAttribute('aria-busy', 'true');
        this.button.disabled = true;
        this.querySelector('[data-status]').textContent = this.dataset.adding;
        let added = false;
        let releaseCart;
        try {
          if (!window.IllumikidsPackCart) throw new Error(this.dataset.error);
          releaseCart = await window.IllumikidsPackCart.acquire();
          const drawer = document.querySelector('cart-drawer');
          const fast = Boolean(drawer?.querySelector('.drawer__inner-empty')) &&
            typeof drawer.renderContents === 'function' && typeof drawer.getSectionsToRender === 'function';
          const cart = fast ? null : await window.IllumikidsPackCart.reconcile();
          const root = this.dataset.root;
          const quantities = new Map();
          for (const select of this.selected.querySelectorAll('select')) {
            if (!select.value || select.selectedOptions[0].disabled) throw new Error(this.dataset.error);
            const option = select.selectedOptions[0];
            const tier = Number(this.selected.dataset.quantity);
            const small = option.dataset.title.startsWith('Petite');
            const discountCode = tier > 1 ? `${tier >= 3 ? 'trio' : 'duo'}_${small ? 'small' : 'large'}` : '';
            const key = `${select.value}:${discountCode}`;
            const entry = quantities.get(key) || { id: Number(select.value), quantity: 0, discountCode };
            entry.quantity += 1;
            quantities.set(key, entry);
          }
          const items = [...quantities.values()].map(({ id, quantity, discountCode }) => ({
            id,
            quantity,
            properties: discountCode ? { _illumikids_discount: discountCode } : {}
          }));
          if (this.dataset.gift && this.dataset.giftReady === 'true' && (fast || !cart.items.some(item => String(item.variant_id) === this.dataset.gift))) items.push({ id: Number(this.dataset.gift), quantity: 1 });
          const sections = fast ? drawer.getSectionsToRender().map(section => section.id) : [];
          const response = await window.fetch(`${root}cart/add.js`, {
            method: 'POST', illumikidsSkipGiftGuard: true, headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items, ...(fast ? { sections, sections_url: window.location.pathname } : {}) })
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
          added = true;
          if (fast && sections.every(id => result.sections?.[id])) {
            drawer.setActiveElement?.(this.button);
            drawer.classList.remove('is-empty');
            drawer.renderContents({ ...result, item_count: result.items.reduce((sum, item) => sum + item.quantity, 0) });
            const confirmed = await window.IllumikidsPackCart.reconcile();
            if (confirmed.illumikids_pack_changed) await window.IllumikidsPackCart.refresh(confirmed, { silent: true });
            return;
          }
          const normalized = await window.IllumikidsPackCart.reconcile();
          if (drawer && typeof drawer.renderContents === 'function') {
            if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(this.button);
            drawer.classList.remove('is-empty');
            await window.IllumikidsPackCart.refresh(normalized);
          } else {
            window.location.assign(`${root}cart`);
          }
        } catch (error) {
          if (added) window.location.assign(`${this.dataset.root}cart`);
          else { this.error.textContent = error.message || this.dataset.error; this.error.hidden = false; }
        } finally {
          releaseCart?.();
          this.pending = false;
          this.removeAttribute('aria-busy');
          this.button.disabled = false;
          this.querySelector('[data-status]').textContent = '';
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["illumikids-cart-size"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('illumikids-cart-size-selector')) {
  customElements.define('illumikids-cart-size-selector', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.select = this.querySelector('select');
      this.error = this.querySelector('[role="alert"]');
      this.querySelector('[data-illumikids-upgrade]')?.addEventListener('click', event => {
        event.preventDefault();
        if (this.hasAttribute('aria-busy')) return;
        this.select.value = this.dataset.largeVariant;
        this.changeSize(this.dataset.largeVariant);
      });
      this.addEventListener('change', event => {
        event.stopImmediatePropagation();
        if (event.target === this.select) this.changeSize(this.select.value);
      });
    }

    async request(path, body) {
      const response = await window.fetch(`${this.dataset.root}${path}`, {
        method: body ? 'POST' : 'GET',
      illumikidsSkipGiftGuard: true,
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        ...(body ? { body: JSON.stringify(body) } : { cache: 'no-store' })
      });
      const data = await response.json();
      if (!response.ok || data.status >= 400 || data.errors) {
        throw new Error(data.description || (typeof data.errors === 'string' && data.errors) || this.dataset.error);
      }
      return data;
    }

    properties(item) {
      return JSON.stringify(Object.entries(item.properties || {})
        .sort(([a], [b]) => a.localeCompare(b)));
    }

    matchesSource(item, source) {
      return String(item.variant_id) === String(source.variant_id)
        && this.properties(item) === this.properties(source)
        && item.selling_plan_allocation?.selling_plan?.id === source.selling_plan_allocation?.selling_plan?.id;
    }

    replacementProperties(source, nextVariant) {
      const properties = { ...(source.properties || {}) };
      if (!this.dataset.smallVariant || !this.dataset.largeVariant) return properties;
      const discount = source.properties?._illumikids_discount;
      const nextIsSmall = String(nextVariant) === this.dataset.smallVariant;
      const nextIsLarge = String(nextVariant) === this.dataset.largeVariant;
      if (!nextIsSmall && !nextIsLarge) return properties;
      const isDuo = discount === 'duo_small' || discount === 'duo_large';
      const isTrio = discount === 'trio_small' || discount === 'trio_large';
      if (!isDuo && !isTrio) return properties;
      delete properties._illumikids_discount;
      if (isDuo) properties._illumikids_discount = nextIsSmall ? 'duo_small' : 'duo_large';
      if (isTrio) properties._illumikids_discount = nextIsSmall ? 'trio_small' : 'trio_large';
      return properties;
    }

    matchesDestination(item, source, nextVariant) {
      return String(item.variant_id) === String(nextVariant)
        && this.properties(item) === this.properties({ properties: this.replacementProperties(source, nextVariant) })
        && item.selling_plan_allocation?.selling_plan?.id === source.selling_plan_allocation?.selling_plan?.id;
    }

    findLine(cart, source) {
      return cart.items.find(item => item.key === source.key)
        || cart.items.find(item => this.matchesSource(item, source));
    }

    async refresh(drawer, cart, sections) {
      if (drawer.matches('cart-items')) return window.IllumikidsPackCart.refresh(cart, { silent: true });
      if (!sections.every(id => cart.sections?.[id])) {
        const url = new URL(window.location.href);
        url.searchParams.set('sections', sections.join(','));
        const response = await window.fetch(url.pathname + url.search, { cache: 'no-store' });
        if (!response.ok) throw new Error(this.dataset.error);
        cart.sections = await response.json();
      }
      if (!sections.every(id => cart.sections?.[id])) throw new Error(this.dataset.error);
      drawer.renderContents(cart);
    }

    async rollback(source, nextVariant, destinationBefore) {
      const cart = await this.request('cart.js');
      const original = this.findLine(cart, source);
      if (!original || original.quantity !== source.quantity) return cart;
      const destinations = cart.items.filter(item => this.matchesDestination(item, source, nextVariant));
      if (destinations.length !== 1) return cart;
      const destination = destinations[0];
      if (destination.quantity <= destinationBefore) return cart;
      if (destination.quantity > destinationBefore + source.quantity) return cart;
      return this.request('cart/change.js', { id: destination.key, quantity: destinationBefore });
    }

    async changeSize(nextVariant) {
      const drawer = this.closest('cart-drawer, cart-items');
      if (!drawer || !nextVariant || nextVariant === this.dataset.currentVariant) return;
      if (drawer.dataset.variantPending === 'true') {
        this.select.value = this.dataset.currentVariant;
        return;
      }
      drawer.dataset.variantPending = 'true';
      drawer.inert = true;
      drawer.setAttribute('aria-busy', 'true');
      this.setAttribute('aria-busy', 'true');
      this.error.hidden = true;
      const scroll = drawer.querySelector('.drawer__contents')?.scrollTop || 0;
      const sections = drawer.getSectionsToRender().map(section => section.section || section.id);
      let source;
      let destinationBefore = 0;
      let attemptedAdd = false;
      let committed = false;
      let message = '';
      let release;
      try {
        if (!window.IllumikidsPackCart) throw new Error(this.dataset.error);
        release = await window.IllumikidsPackCart.acquire();
        const before = await this.request('cart.js');
        source = before.items.find(item => item.key === this.dataset.lineKey);
        if (!source) throw new Error(this.dataset.error);
        destinationBefore = before.items.filter(item => this.matchesDestination(item, source, nextVariant))
          .reduce((sum, item) => sum + item.quantity, 0);
        const replacement = { id: Number(nextVariant), quantity: source.quantity, properties: this.replacementProperties(source, nextVariant) };
        const plan = source.selling_plan_allocation?.selling_plan?.id;
        if (plan) replacement.selling_plan = plan;
        attemptedAdd = true;
        const added = await this.request('cart/add.js', { items: [replacement] });
        const destinations = (added.items || []).filter(item => this.matchesDestination(item, source, nextVariant));
        let original = source;
        if (destinations.length !== 1 || destinations[0].quantity !== destinationBefore + source.quantity) {
          const afterAdd = await this.request('cart.js');
          original = this.findLine(afterAdd, source);
          const destinationQuantity = afterAdd.items.filter(item => this.matchesDestination(item, source, nextVariant))
            .reduce((sum, item) => sum + item.quantity, 0);
          if (!original || original.quantity !== source.quantity || destinationQuantity !== destinationBefore + source.quantity) {
            throw new Error(this.dataset.error);
          }
        }
        const removeSource = id => this.request('cart/change.js', {
          id, quantity: 0, sections, sections_url: window.location.pathname
        });
        let changed;
        try {
          changed = await removeSource(original.key);
        } catch (error) {
          const actual = await this.request('cart.js');
          const found = this.findLine(actual, source);
          if (!found) {
            const count = actual.items.filter(item => String(item.product_id) === this.dataset.productId)
              .reduce((sum, item) => sum + item.quantity, 0);
            const expected = before.items.filter(item => String(item.product_id) === this.dataset.productId)
              .reduce((sum, item) => sum + item.quantity, 0);
            if (count !== expected) throw error;
            changed = actual;
          } else {
            if (found.quantity !== source.quantity || found.key === original.key) throw error;
            changed = await removeSource(found.key);
          }
        }
        committed = true;
        await this.refresh(drawer, await window.IllumikidsPackCart.reconcile(changed), sections);
      } catch (error) {
        message = error.message || this.dataset.error;
        try {
          const actual = attemptedAdd && !committed
            ? source ? await this.rollback(source, nextVariant, destinationBefore) : await this.request('cart.js')
            : await this.request('cart.js');
          await this.refresh(drawer, await window.IllumikidsPackCart.reconcile(actual), sections);
        } catch (refreshError) {
          message = this.dataset.error;
        }
      } finally {
        if (release) release();
        drawer.inert = false;
        drawer.removeAttribute('aria-busy');
        delete drawer.dataset.variantPending;
        this.removeAttribute('aria-busy');
        const selectors = [...drawer.querySelectorAll('illumikids-cart-size-selector')];
        const control = selectors.find(element => element.dataset.currentVariant === (committed ? nextVariant : this.dataset.currentVariant))
          || selectors.find(element => element.dataset.productId === this.dataset.productId) || this;
        if (control.select) control.select.value = control.dataset.currentVariant;
        if (message && control.error) {
          control.error.textContent = message;
          control.error.hidden = false;
        }
        requestAnimationFrame(() => {
          control.select?.focus({ preventScroll: true });
          const contents = drawer.querySelector('.drawer__contents');
          if (contents) contents.scrollTop = scroll;
        });
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["illumikids-gift-guard"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('illumikids-gift-guard')) {
    customElements.define('illumikids-gift-guard', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.nativeFetch = window.fetch.bind(window);
        this.message = this.querySelector('[role="alert"]');
        this.onSubmit = this.onSubmit.bind(this);
        document.addEventListener('submit', this.onSubmit, true);

        if (this.dataset.blockDirect === 'true') {
          window.location.replace(this.dataset.boardUrl);
          return;
        }

        if (!window.illumikidsGiftGuardFetchInstalled) {
          window.illumikidsGiftGuardFetchInstalled = true;
          const guard = this;
          window.fetch = async function(input, init) {
            const response = await guard.nativeFetch(input, init);
            if (!response.ok || guard.internalRequest || init?.illumikidsSkipGiftGuard || !guard.isCartMutation(input)) return response;

            try {
              const replacement = await guard.reconcile(guard.requestSections(init));
              return replacement || response;
            } catch (error) {
              console.error('Illumikids gift guard:', error);
              return response;
            }
          };
        }

        this.reconcile(['cart-drawer', 'cart-icon-bubble', 'main-cart-items', 'main-cart-footer'])
          .then(response => {
            if (!response) return;
            if (this.isCartPage()) window.location.reload();
            else this.renderDrawer(response);
          })
          .catch(error => console.error('Illumikids gift guard:', error));
      }

      disconnectedCallback() {
        document.removeEventListener('submit', this.onSubmit, true);
      }

      isCartMutation(input) {
        const url = typeof input === 'string' ? input : input?.url || '';
        return /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(url);
      }

      requestSections(init) {
        if (typeof init?.body !== 'string') return [];
        try {
          const body = JSON.parse(init.body);
          return Array.isArray(body.sections) ? body.sections : [];
        } catch (error) {
          return [];
        }
      }

      async cart() {
        const response = await this.nativeFetch(`${this.dataset.root}cart.js`, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Unable to read cart');
        return response.json();
      }

      async reconcile(sections = []) {
        if (this.reconcilePromise) return this.reconcilePromise;
        this.reconcilePromise = this.removeOrphanedGift(sections);
        try {
          return await this.reconcilePromise;
        } finally {
          this.reconcilePromise = null;
        }
      }

      async removeOrphanedGift(sections) {
        const cart = await this.cart();
        const gift = cart.items.find(item => String(item.variant_id) === this.dataset.giftVariant);
        const hasBoard = cart.items.some(item => item.handle === this.dataset.boardHandle && item.quantity > 0);
        this.cartIsValid = !gift || hasBoard;
        if (!gift || hasBoard) return null;

        this.internalRequest = true;
        try {
          const response = await this.nativeFetch(this.dataset.changeUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              id: gift.key,
              quantity: 0,
              ...(sections.length ? { sections, sections_url: window.location.pathname } : {})
            })
          });
          if (!response.ok) throw new Error('Unable to remove orphaned gift');
          this.cartIsValid = true;
          this.showMessage();
          return response;
        } finally {
          this.internalRequest = false;
        }
      }

      async onSubmit(event) {
        const submitter = event.submitter;
        if (!submitter || submitter.name !== 'checkout') return;
        if (event.target.dataset.illumikidsGiftGuardPassed === 'true') {
          delete event.target.dataset.illumikidsGiftGuardPassed;
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();
        submitter.disabled = true;
        try {
          const response = await this.reconcile(['cart-drawer', 'cart-icon-bubble', 'main-cart-items', 'main-cart-footer']);
          if (response) {
            this.showMessage();
            if (this.isCartPage()) window.location.reload();
            else this.renderDrawer(response);
            return;
          }
          event.target.dataset.illumikidsGiftGuardPassed = 'true';
          submitter.disabled = false;
          event.target.requestSubmit(submitter);
        } catch (error) {
          console.error('Illumikids gift guard:', error);
          this.showMessage();
        } finally {
          submitter.disabled = false;
        }
      }

      async renderDrawer(response) {
        const drawer = document.querySelector('cart-drawer');
        if (!drawer || typeof drawer.renderContents !== 'function') return;
        const data = await response.clone().json();
        if (data.sections) drawer.renderContents(data);
      }

      isCartPage() {
        return window.location.pathname === this.dataset.cartUrl || window.location.pathname === `${this.dataset.cartUrl}/`;
      }

      showMessage() {
        if (!this.message) return;
        this.message.textContent = this.dataset.message;
        this.message.hidden = false;
        clearTimeout(this.messageTimer);
        this.messageTimer = setTimeout(() => { this.message.hidden = true; }, 5000);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
